import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { themeLight, spacing } from '@naf/theme';
import { Text, TextVariant } from '@naf/text';
import { propValidationConfig } from './propValidationConfig';
export const Loader = ({
  variant = 'primary',
  size = 'standard',
  label
}) => /*#__PURE__*/React.createElement(SpinnerContainer, null, /*#__PURE__*/React.createElement(Spinner, {
  variant: variant,
  size: size
}), label && /*#__PURE__*/React.createElement(Text, {
  variant: size === 'small' ? TextVariant.Small : TextVariant.BodyText
}, label));
const spin = keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
const SpinnerContainer = styled.div.withConfig({
  displayName: "loader__SpinnerContainer",
  componentId: "sc-1t8rju9-0"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;"]);
const Spinner = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "loader__Spinner",
  componentId: "sc-1t8rju9-1"
})(["width:", "px;height:", "px;border:1.5px solid;border-radius:50%;box-sizing:border-box;animation:", " 0.6s linear infinite;", " ", " ", " ", ""], props => props.size, props => props.size, spin, ({
  size
}) => size === 'standard' && css(["width:", ";height:", ";border:3px solid;"], spacing.space32, spacing.space32), ({
  size
}) => size === 'small' && css(["width:", ";height:", ";border:1.5px solid;"], spacing.space16, spacing.space16), ({
  variant
}) => variant === 'primary' && css(["border-color:", ";border-top-color:", ";"], ({
  theme
}) => theme.componentColors ? theme.componentColors.navigation.inactive : themeLight.componentColors.navigation.inactive, ({
  theme
}) => theme.componentColors ? theme.componentColors.navigation.active : themeLight.componentColors.navigation.active), ({
  variant
}) => variant === 'neutral' && css(["border-color:", ";border-top-color:", ";"], ({
  theme
}) => theme.componentColors ? theme.componentColors.navigation.inactive : themeLight.componentColors.navigation.inactive, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText));
export default Loader;
//# sourceMappingURL=loader.js.map